module.exports = __webpack_public_path__ + "static/media/computers3.6d6b4db6.png";